export enum YandexMetrikaAbTestFlagKeys {
  SearchEngineStrategy = 'spa1258',
}
